// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3F0fz","errorLogs":"EditorFooter_errorLogs__3QS7X"};